<ion-row style="width: 100%" class="ion-no-padding">
  <ion-col size="12" class="ion-no-padding">
    <app-customer-info
      *ngIf="
        (!currentUser ||
          (!currentUser.only_dinein && !currentUser.only_visitor)) &&
        !store_info?.only_visitors_app
      "
    ></app-customer-info>

    <app-customer-register-only-dine-in
      *ngIf="
        currentUser && (currentUser.only_dinein || currentUser.only_visitor)
      "
    ></app-customer-register-only-dine-in>

    <app-delivery-method-address
      [cartMode]="true"
    ></app-delivery-method-address>
    <app-cart-preorder-item> </app-cart-preorder-item>

    <app-delivery-info
      *ngIf="currentUser && orderPickup == false && dineIn == false"
      size="12"
    ></app-delivery-info>

    <app-payment-methods></app-payment-methods>

    <app-extra-choices></app-extra-choices>

    <app-cart-points
      *ngIf="
        !currentUser ||
        (!currentUser.only_dinein &&
          !currentUser.only_visitor &&
          !currentUser.uposMoUser)
      "
    ></app-cart-points>
    <app-add-coupon-code
      *ngIf="
        showAddCouponCodeComponent &&
        (!currentUser ||
          (!currentUser.only_dinein && !currentUser.only_visitor))
      "
    ></app-add-coupon-code>
    <app-cart-active-coupons
      *ngIf="
        !currentUser || (!currentUser.only_dinein && !currentUser.only_visitor)
      "
    ></app-cart-active-coupons>

    <app-checkbox-promotions
      *ngIf="
        !currentUser || (!currentUser.only_dinein && !currentUser.only_visitor)
      "
    ></app-checkbox-promotions>
    <app-order-comments></app-order-comments>

    <app-cart-list></app-cart-list>
  </ion-col>
</ion-row>
